import { submitContactForm } from '~/utils/contactForm'

export type PromoLead = {
  /** Phone as typed in the popup — normalisation is the backend's job. */
  phone: string
  /** Shareable configurator link that must reach the manager. */
  projectUrl: string
}

const buildText = ({ phone, projectUrl }: PromoLead): string =>
  `<b>🆕 Lead — configurator (popup)</b>
<b>Telefon:</b> ${phone}
<b>Proiect:</b> ${projectUrl}`

/**
 * Delivers the popup lead over plain HTTP instead of the chat socket, which
 * has no polling fallback and silently swallows the request when it never
 * connects. Throws unless the server confirms it took the lead.
 */
export async function submitPromoLead(lead: PromoLead): Promise<void> {
  await submitContactForm({
    text: buildText(lead),
    source: 'popup',
    phone: lead.phone,
    message: lead.projectUrl,
  })
}
